import * as React from 'react'

function DownloadIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 8656"
            transform="translate(172 2597)"
            d="M0 0h24v24H0z"
            fill="none"
            stroke="#707070"
          />
        </clipPath>
      </defs>
      <g data-name="Download large black mobile" transform="translate(-172 -2597)" clipPath="url(#a)">
        <g data-name="Group 56177">
          <g data-name="Group 56176">
            <g data-name="Group 56175">
              <path data-name="Path 17173" d="M184.7 2601v9.428h-1.4V2601zM193 2616.804h-18v-1.4h18z" fill="#263238" />
              <path
                data-name="Path 17173"
                d="M176.401 2608.55v7.653h-1.4v-7.653zM192.999 2608.55v7.653h-1.4v-7.653z"
                fill="#263238"
              />
              <g data-name="Group 56174">
                <path
                  data-name="Subtraction 422"
                  d="M188.352 2607.85l-4.31 4.31-4.31-4.31h2.121l2.192 2.193 2.192-2.192h2.122z"
                  fill="#263238"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default DownloadIcon
